module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/cbs-icon/cbs-icon.component.scss
// module id = ./src/app/shared/cbs-icon/cbs-icon.component.scss
// module chunks = main